import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
// import {
//   triggerWelcomeEmailAction,
//   triggerWelcomeEmailHandler,
// } from "../../redux/action/triggerWelcomeEmail";
import Loader from "../Loder/loader";
import { useCommonMessage } from "../../common/CommonMessage";
import { ThemeContext } from "../../common/themeContext";
import { getItem } from "../../common/localStorage";
import Dragger from "../Dragger/Dragger";
import {
  createEmailTemplateAction,
  createEmailTemplateHandler,
} from "../../redux/action/createEmailTemplate";
import {
  updateEmailTemplateAction,
  updateEmailTemplateHandler,
} from "../../redux/action/updateEmailTemplate";
import { handleKeyPressSpace } from "../../common/CommonFunctions";
import {
  useAdminPermissions,
  VIEW_ONLY_EMPTY_MESSAGE,
} from "../../hooks/useAdminPermissions";

const ManageEmailTemplates = () => {
  const triggerWelcomeSelector = useSelector((state) => state?.triggerWelcome);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const messageApi = useCommonMessage();
  const { brandId } = useContext(ThemeContext);
  const { hasEmailTemplateViewOnly, isPending: permissionsPending } =
    useAdminPermissions();
  const isViewOnly = hasEmailTemplateViewOnly;

  // const storedTheme = getItem("theme");
  const { state } = useLocation();
  const manageData = state?.manageData;
  const [deleteUploadedFile, setDeleteUploadedFile] = useState("");
  const [isEditorEmpty, setIsEditorEmpty] = useState(true);

  useEffect(() => {
    if (triggerWelcomeSelector?.message) {
      messageApi.open({
        type: "error",
        content: triggerWelcomeSelector?.message,
      });
      dispatch(createEmailTemplateAction.triggerWelcomeReset());
    } else if (triggerWelcomeSelector?.data?.statusCode === 200) {
      messageApi.open({
        type: "success",
        content: triggerWelcomeSelector?.data?.message,
      });
      dispatch(createEmailTemplateAction.triggerWelcomeReset());
      navigate("/email-templates");
    }
  }, [triggerWelcomeSelector]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      templateName: manageData?.templateName || "",
      subject: manageData?.emailSubject || "",
      body: manageData?.emailBody || "",
      title: "",
      language: "english",
    },
    validate: (values) => {
      const errors = {};
      if (!values?.templateName) {
        errors.selection = "Please Enter Template Name";
      }
      return errors;
    },

    onSubmit: (value) => {
      const cleanTemplateName = value?.templateName
        ?.trim()
        ?.replace(/\s+/g, " ");
      const common = {
        eventType: brandId === 1 ? "WELCOME_HC" : "WELCOME_PC",
        brandId: brandId,
        templateName: cleanTemplateName,
        enabled: manageData?.id ? manageData.enabled : false,
        emailBody: value?.body,
        emailBodySpanish: value?.bodySpanish || "",
        emailSubject: value?.subject || "",
        emailSubjectSpanish: value?.subjectSpanish || "",
      };
      if (manageData?.id) {
        const updatePayload = { id: manageData.id, ...common };
        dispatch(updateEmailTemplateHandler(updatePayload));
      } else {
        dispatch(createEmailTemplateHandler(common));
      }
    },
  });
  const createEmailTemplate = useSelector(
    (state) => state?.createEmailTemplate,
  );
  const updateEmailTemplate = useSelector(
    (state) => state?.updateEmailTemplate,
  );
  const showError = formik?.errors?.selection && !formik?.values?.templateName;
  const templateHtml = manageData?.emailBody || formik.values.body || "";
  const hasHtmlContent = Boolean(templateHtml?.trim());

  useEffect(() => {
    if (createEmailTemplate?.message) {
      messageApi.open({
        type: "error",
        content: createEmailTemplate?.message,
      });
      dispatch(createEmailTemplateAction.createEmailTemplateReset());
    } else if (createEmailTemplate?.data?.statusCode === 200) {
      messageApi.open({
        type: "success",
        content: createEmailTemplate?.data?.message,
      });
      dispatch(createEmailTemplateAction.createEmailTemplateReset());
      navigate("/email-templates");
    }
  }, [createEmailTemplate]);

  useEffect(() => {
    if (updateEmailTemplate?.message) {
      messageApi.open({
        type: "error",
        content: updateEmailTemplate?.message,
      });
      dispatch(updateEmailTemplateAction.updateEmailTemplateReset());
    } else if (updateEmailTemplate?.data?.statusCode === 200) {
      messageApi.open({
        type: "success",
        content: updateEmailTemplate?.data?.message,
      });
      dispatch(updateEmailTemplateAction.updateEmailTemplateReset());
      navigate("/email-templates");
    }
  }, [updateEmailTemplate]);

  useEffect(() => {
    const editorContent =
      formik.values.language === "english"
        ? formik.values.body
        : formik.values.bodySpanish;
    const cleanedContent = editorContent
      ? editorContent.replace(/&nbsp;|<br\s*\/?>/gi, " ")
      : "";
    setIsEditorEmpty(!cleanedContent || cleanedContent.trim() === "");
  }, [formik.values.body, formik.values.bodySpanish, formik.values.language]);

  return (
    <>
      {(triggerWelcomeSelector?.isLoading ||
        createEmailTemplate?.isLoading ||
        permissionsPending) && <Loader loaderTransForm="loaderTransForm" />}
      <div className="rightside">
        <div className="rightcontent">
          {isViewOnly && manageData?.id ? (
            <>
              <p>
                <strong>Welcome Email Templates</strong>
              </p>
              <CustomBreadcrumb
                items={[
                  { text: "Home" },
                  {
                    text: "Welcome Email Templates",
                    onClick: () => navigate("/email-templates"),
                  },
                  { text: "View Template", active: true },
                ]}
              />
              <div className="release-document-view-header mb-30">
                <p className="release-document-view-title">View Template</p>
                <hr className="my-20" />
                <p className="release-document-view-name">
                  {manageData?.templateName}
                </p>
              </div>
              <div className="table-padding mb-40 release-document-view-panel">
                <p className="heedprodct mb-0">Welcome Email</p>
                <div className="release-document-view-tab">HTML</div>
                <hr className="m-0" />
                <div className="release-document-view-content">
                  {hasHtmlContent ? (
                    <div
                      className="release-document-view-html"
                      dangerouslySetInnerHTML={{ __html: templateHtml }}
                    />
                  ) : (
                    <p className="release-document-view-empty">
                      {VIEW_ONLY_EMPTY_MESSAGE}
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="text-end">
                <button
                  type="button"
                  onClick={() => navigate("/email-templates")}
                  className="border-0 py3 fw-18 gbo ms-auto bgtransparent addcreatebtn"
                >
                  <span>Go back to listing</span>
                </button>
              </div> */}
            </>
          ) : (
            <>
              <p>
                <strong>WelcomeEmail Template</strong>
              </p>
              <CustomBreadcrumb
                items={[
                  { text: "Home" },
                  {
                    text: "Send Welcome Email Notification",
                    onClick: () => navigate("/email-templates"),
                  },
                  {
                    text: manageData?.id ? "Edit Template" : "Create Template",
                    active: true,
                  },
                ]}
              />
              <div className="sectionpadding welcometemplateMargin mb-30">
                <div className="mb-0 heedprodct">
                  {manageData?.id ? "Edit Template" : "Create Template"}
                </div>
                <hr />
                <div className="welcometemplate login-form p-20">
                  <div className="w-md-50 pe-md-2 mb-lg-0 mb-3 position-relative">
                    <label className="mb-2">Template Name*</label>
                    <input
                      type="text"
                      name="templateName"
                      placeholder="Template Name"
                      className="form-control"
                      value={formik.values.templateName || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      onKeyDown={handleKeyPressSpace}
                      maxLength={50}
                    />
                    {showError && (
                      <div className="error">{formik?.errors?.selection}</div>
                    )}
                  </div>
                </div>
                <div className="welcometemplate">
                  <div className="fs-18 producttitle">Welcome Email</div>
                  <Dragger
                    deleteUploadedFile={deleteUploadedFile}
                    setDeleteUploadedFile={setDeleteUploadedFile}
                    state={state}
                    onlyHtmlEditer={true}
                    initialHtml={manageData?.emailBody}
                    initialHtmlSpanish={manageData?.emailBodySpanish}
                    onContentChange={(val) => formik.setFieldValue("body", val)}
                    onContentChangeSpanish={(val) =>
                      formik.setFieldValue("bodySpanish", val)
                    }
                    hideSaveButton={true}
                  />
                </div>
              </div>
              <div className="text-end bgt">
                {!isEditorEmpty && (
                  <button
                    type="button"
                    onClick={formik.handleSubmit}
                    className="sbg border-0 py3 fw-18 gbo continuebtn savebtn"
                  >
                    Save
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ManageEmailTemplates;
